import { render, staticRenderFns } from "./dbEventList.vue?vue&type=template&id=ed6d8ee6&scoped=true&"
import script from "./dbEventList.vue?vue&type=script&lang=js&"
export * from "./dbEventList.vue?vue&type=script&lang=js&"
import style0 from "./dbEventList.vue?vue&type=style&index=0&id=ed6d8ee6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6d8ee6",
  null
  
)

export default component.exports